(function () {
    'use strict';

    angular
        .module('app.topicSettingReportSegment',[])
        .factory('topicSettingReportSegmentService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope)
            {
                var service = {};

                function handleRequest(url, method, params)
                {
                    var deferred = $q.defer();
                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params)
                    }

                    $http(req).success(function (response) {
                        deferred.resolve(response);
                    })
                    .error(function () {
                        deferred.reject(null);
                    });

                    return deferred.promise;
                }

                function getListTopic()
                {
                    var url_getListTopic = $rootScope.apiUrl + 'mention/getAllTopic';
                    return handleRequest(url_getListTopic, 'GET', null);
                }

                service.getListTopic = getListTopic;
                return service;
            }
        ])
})();
